export const categories = [
  { slug: "romance", name: "恋爱浪漫", icon: "ri-heart-line", color: "accent", count: 128 },
  { slug: "fantasy", name: "奇幻冒险", icon: "ri-magic-line", color: "primary", count: 96 },
  { slug: "action", name: "热血动作", icon: "ri-flashlight-line", color: "secondary", count: 87 },
  { slug: "drama", name: "都市剧情", icon: "ri-building-line", color: "accent", count: 74 },
  { slug: "comedy", name: "搞笑日常", icon: "ri-emotion-laugh-line", color: "primary", count: 63 },
  { slug: "thriller", name: "悬疑惊悚", icon: "ri-ghost-line", color: "secondary", count: 52 },
  { slug: "historical", name: "历史古风", icon: "ri-ancient-gate-line", color: "accent", count: 41 },
  { slug: "bl", name: "BL耽美", icon: "ri-user-heart-line", color: "primary", count: 115 },
];

export const featuredComics = [
  {
    slug: "secretarys-escape",
    title: "秘书的逃脱",
    author: "朴智恩",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20featuring%20a%20stylish%20female%20office%20worker%20in%20a%20modern%20city%20setting%2C%20romantic%20drama%20theme%2C%20soft%20warm%20lighting%2C%20delicate%20lineart%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20elegant%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    rating: 9.6,
    chapters: 87,
    status: "连载中",
    description: "能力出众的秘书金秀雅，在一场意外中发现社长隐藏的秘密后，她的人生轨迹彻底改变。为了逃离这场精心设计的陷阱，她必须步步为营...",
    updatedAt: "2026-08-04",
    isHot: true,
    isNew: false,
  },
  {
    slug: "demon-kings-daughter",
    title: "魔王的千金",
    author: "李星辰",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20illustration%20of%20a%20majestic%20female%20warrior%20with%20dark%20hair%20in%20a%20fantasy%20world%2C%20magical%20elements%2C%20dramatic%20lighting%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20epic%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    rating: 9.8,
    chapters: 124,
    status: "连载中",
    description: "作为魔王的独生女，艾琳从小被保护在城堡中。直到人类联军攻入魔界，她才发现自己的真实身份远比想象中更加复杂...",
    updatedAt: "2026-08-03",
    isHot: true,
    isNew: false,
  },
  {
    slug: "rebirth-of-sword-god",
    title: "剑神重生",
    author: "金武英",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20cover%20featuring%20a%20powerful%20male%20swordsman%20with%20flowing%20hair%2C%20martial%20arts%20action%20theme%2C%20dramatic%20pose%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20intense%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    rating: 9.5,
    chapters: 156,
    status: "连载中",
    description: "一代剑神林逸在与魔尊大战中陨落，却意外重生回到少年时代。带着前世的记忆和剑道感悟，他誓要改写命运...",
    updatedAt: "2026-08-04",
    isHot: true,
    isNew: false,
  },
  {
    slug: "office-romance-secret",
    title: "办公室恋情的秘密",
    author: "韩素希",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20charming%20Korean%20manhwa%20cover%20showing%20two%20attractive%20office%20colleagues%20sharing%20a%20tender%20moment%2C%20romantic%20comedy%20vibe%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20sweet%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    rating: 9.3,
    chapters: 64,
    status: "连载中",
    description: "在同一家公司工作的两人，因为一次意外的工作项目被分配到一起。朝夕相处中，感情悄然滋生...",
    updatedAt: "2026-08-02",
    isHot: false,
    isNew: true,
  },
  {
    slug: "moonlight-garden",
    title: "月光花园",
    author: "崔美妍",
    category: "drama",
    cover: "https://readdy.ai/api/search-image?query=A%20melancholic%20Korean%20manhwa%20cover%20featuring%20a%20beautiful%20woman%20in%20a%20moonlit%20garden%2C%20emotional%20drama%20theme%2C%20soft%20atmospheric%20lighting%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20poetic%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    rating: 9.7,
    chapters: 93,
    status: "完结",
    description: "在月光下的古老花园中，一段跨越时空的爱情故事缓缓展开。现代女孩与百年前的画家，命运的红线将两人紧紧相连...",
    updatedAt: "2026-07-28",
    isHot: true,
    isNew: false,
  },
  {
    slug: "mystery-detective-agency",
    title: "神秘侦探社",
    author: "张道允",
    category: "thriller",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20cover%20with%20a%20detective%20in%20a%20dark%20alley%2C%20noir%20atmosphere%2C%20suspenseful%20thriller%20theme%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20intriguing%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    rating: 9.4,
    chapters: 72,
    status: "连载中",
    description: "曾经的精英刑警因一桩冤案离开警队，成立私人侦探社。每一起案件背后都隐藏着不为人知的秘密...",
    updatedAt: "2026-08-01",
    isHot: false,
    isNew: true,
  },
  {
    slug: "princess-conspiracy",
    title: "公主的阴谋",
    author: "尹素婉",
    category: "historical",
    cover: "https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20manhwa%20cover%20of%20a%20princess%20in%20traditional%20hanbok%2C%20historical%20palace%20drama%2C%20elegant%20royal%20atmosphere%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20refined%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    rating: 9.6,
    chapters: 108,
    status: "连载中",
    description: "朝鲜王朝时期，最受宠爱的公主发现宫中暗流涌动。为了守护王室，她必须在权力斗争中开辟自己的道路...",
    updatedAt: "2026-08-03",
    isHot: false,
    isNew: false,
  },
  {
    slug: "daily-life-with-cat",
    title: "与猫同居的日子",
    author: "宋多惠",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20Korean%20manhwa%20cover%20with%20a%20girl%20and%20an%20adorable%20cat%2C%20slice%20of%20life%20comedy%2C%20cozy%20and%20heartwarming%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20playful%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    rating: 9.2,
    chapters: 48,
    status: "连载中",
    description: "独居女孩偶然救助了一只流浪猫，从此一人一猫开始了爆笑又温馨的同居生活。每天的日常都充满了意外的快乐...",
    updatedAt: "2026-08-04",
    isHot: false,
    isNew: true,
  },
];

export const latestUpdates = [
  { ...({
    slug: "secretarys-escape",
    title: "秘书的逃脱",
    chapter: "第87话",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20featuring%20a%20stylish%20female%20office%20worker%20in%20a%20modern%20city%20setting%2C%20romantic%20drama%20theme%2C%20soft%20warm%20lighting%2C%20delicate%20lineart%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20elegant%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    updatedTime: "10分钟前",
  }) },
  { ...({
    slug: "demon-kings-daughter",
    title: "魔王的千金",
    chapter: "第124话",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20illustration%20of%20a%20majestic%20female%20warrior%20with%20dark%20hair%20in%20a%20fantasy%20world%2C%20magical%20elements%2C%20dramatic%20lighting%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20epic%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    updatedTime: "25分钟前",
  }) },
  { ...({
    slug: "rebirth-of-sword-god",
    title: "剑神重生",
    chapter: "第156话",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20cover%20featuring%20a%20powerful%20male%20swordsman%20with%20flowing%20hair%2C%20martial%20arts%20action%20theme%2C%20dramatic%20pose%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20intense%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    updatedTime: "1小时前",
  }) },
  { ...({
    slug: "office-romance-secret",
    title: "办公室恋情的秘密",
    chapter: "第64话",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20charming%20Korean%20manhwa%20cover%20showing%20two%20attractive%20office%20colleagues%20sharing%20a%20tender%20moment%2C%20romantic%20comedy%20vibe%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20sweet%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    updatedTime: "1小时前",
  }) },
  { ...({
    slug: "moonlight-garden",
    title: "月光花园",
    chapter: "第93话（完）",
    category: "drama",
    cover: "https://readdy.ai/api/search-image?query=A%20melancholic%20Korean%20manhwa%20cover%20featuring%20a%20beautiful%20woman%20in%20a%20moonlit%20garden%2C%20emotional%20drama%20theme%2C%20soft%20atmospheric%20lighting%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20poetic%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    updatedTime: "2小时前",
  }) },
  { ...({
    slug: "mystery-detective-agency",
    title: "神秘侦探社",
    chapter: "第72话",
    category: "thriller",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20cover%20with%20a%20detective%20in%20a%20dark%20alley%2C%20noir%20atmosphere%2C%20suspenseful%20thriller%20theme%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20intriguing%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    updatedTime: "3小时前",
  }) },
  { ...({
    slug: "princess-conspiracy",
    title: "公主的阴谋",
    chapter: "第108话",
    category: "historical",
    cover: "https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20manhwa%20cover%20of%20a%20princess%20in%20traditional%20hanbok%2C%20historical%20palace%20drama%2C%20elegant%20royal%20atmosphere%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20refined%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    updatedTime: "4小时前",
  }) },
  { ...({
    slug: "daily-life-with-cat",
    title: "与猫同居的日子",
    chapter: "第48话",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20Korean%20manhwa%20cover%20with%20a%20girl%20and%20an%20adorable%20cat%2C%20slice%20of%20life%20comedy%2C%20cozy%20and%20heartwarming%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20playful%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    updatedTime: "5小时前",
  }) },
  { ...({
    slug: "blooming-spring",
    title: "春日的花语",
    author: "姜艺琳",
    chapter: "第35话",
    category: "bl",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20BL%20manhwa%20cover%20showing%20two%20handsome%20young%20men%20in%20a%20spring%20garden%2C%20romantic%20atmosphere%2C%20delicate%20art%20style%2C%20webtoon%20illustration%2C%20clean%20white%20background%2C%20tender%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    updatedTime: "6小时前",
  }) },
  { ...({
    slug: "heavenly-warrior",
    title: "天界武者",
    author: "南宫烈",
    chapter: "第201话",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=An%20epic%20Korean%20manhwa%20cover%20of%20a%20martial%20artist%20floating%20in%20heavenly%20realm%2C%20divine%20energy%20surrounding%2C%20action%20fantasy%20theme%2C%20webtoon%20art%20style%2C%20clean%20white%20background%2C%20grand%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    updatedTime: "8小时前",
  }) },
];

export const hotRankings = [
  { rank: 1, slug: "demon-kings-daughter", title: "魔王的千金", heat: "9.8", icon: "ri-fire-fill" },
  { rank: 2, slug: "moonlight-garden", title: "月光花园", heat: "9.7", icon: "ri-fire-fill" },
  { rank: 3, slug: "secretarys-escape", title: "秘书的逃脱", heat: "9.6", icon: "ri-fire-fill" },
  { rank: 4, slug: "princess-conspiracy", title: "公主的阴谋", heat: "9.6", icon: "ri-fire-fill" },
  { rank: 5, slug: "rebirth-of-sword-god", title: "剑神重生", heat: "9.5", icon: "ri-fire-line" },
  { rank: 6, slug: "mystery-detective-agency", title: "神秘侦探社", heat: "9.4", icon: "ri-fire-line" },
  { rank: 7, slug: "office-romance-secret", title: "办公室恋情的秘密", heat: "9.3", icon: "ri-fire-line" },
  { rank: 8, slug: "daily-life-with-cat", title: "与猫同居的日子", heat: "9.2", icon: "ri-fire-line" },
];